import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { appAddress } from "../App";


function AboutAPI() {
    const [abouts, setAbouts] = useState([]);
    const [callback, setCallback] = useState(false);

    useEffect(() => {
        const getAbouts = async () => {
            try {
                const res = await axios.get(`${appAddress}/api/about`);
                // const res = await axios.get(`/api/about`);
                
                if (Array.isArray(res.data)) {
                    setAbouts(res.data);
                } else {
                    setAbouts(res.data);
                }
            } catch (err) {
                toast.error(err.response.data.msg, {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        };
        getAbouts();
    }, []);


    return {
        aboutUs: [abouts, setAbouts],
        callback: [callback, setCallback]
    };
}

export default AboutAPI;